module.exports = __webpack_public_path__ + "static/media/LogicWedge6_1_row_2.1d043f22.png";